// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type EnrollmentEvent, type EnrollmentEventType } from 'types'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type CreateEnrollmentEventParams = {
  employee_id: string
  enrollment_type: EnrollmentEventType
  enrollment_subtype?: string
  enrollment_window_start_date: string
  enrollment_window_end_date: string
  plan_year: number
  prevent_invite?: boolean
}

export function useCreateEnrollmentEvent () {
  return useMutation<
    EnrollmentEvent,
    GrapeAPIErrorType,
    CreateEnrollmentEventParams
  >({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'post',
        '/api/web/admin/enrollment_event',
        {
          body: params,
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message ?? 'Failed to create enrollment event',
          errors: errors.errors ?? [],
        })
      }
      return response.json
    },
  })
}
